module.exports = __webpack_public_path__ + "images/revo-ea9b633c8b3f92ac0f9a4e70bebe11fe.svg";